const IS_LOADING = "lists/categories/IS_LOADING";
const IS_PARTIAL_LOADING = "lists/categories/IS_PARTIAL_LOADING";
const IS_ERROR = "lists/categories/IS_ERROR";
const CATEGORIES = "lists/categories/CATEGORIES";
const CATEGORY_EDIT = "lists/categories/CATEGORY_EDIT";
const CATEGORY_CREATE = "lists/categories/CATEGORY_CREATE";

export { IS_LOADING, IS_PARTIAL_LOADING, IS_ERROR, CATEGORIES, CATEGORY_EDIT, CATEGORY_CREATE };
